export default "__VITE_ASSET__f1a29b29__"